module.exports = __webpack_public_path__ + "static/img/ad3.759ba10f.png";